export default __webpack_public_path__ + "static/media/flag-namibia.2fee59cc.svg";